import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET = createApiNamespacedConstants('GET');
export const PUT = createApiNamespacedConstants('PUT');
export const TOGGLE = `${NAMESPACE}/TOGGLE`;
